const MILLISECONDS_PER_DAY = 86400000;

export const getSocialFundDaysInStatus = (statusHistories, now = Date.now()) => {
  // La API puede omitir dateEnd cuando su valor es null.
  const currentEntry = (statusHistories || []).find((entry) => entry.dateEnd == null);
  if (!currentEntry?.dateStart) return null;

  const startedAt = new Date(currentEntry.dateStart).getTime();
  if (!Number.isFinite(startedAt)) return null;

  return Math.max(0, Math.floor((now - startedAt) / MILLISECONDS_PER_DAY));
};

// Colores por estado (App\Enum\SocialFundApplicationStatus), compartidos por el
// listado, el selector de estado, la insignia del detalle y el historial:
// azul = A51 trabajando, ámbar = espera la decisión de Dirección, verde =
// aprobada, morado = espera el pago de Administración, naranja = pagada pero
// falta el justificante final (hay que reclamarlo), rojo = denegada,
// gris = cerrada.
const SOCIAL_FUND_STATUS_TONES = {
  blue: { background: "#eef3ff", border: "#cbd9ff", text: "#3d64c7", dot: "#587ef0" },
  amber: { background: "#fffaf0", border: "#f7dfa4", text: "#bf7c00", dot: "#f3aa16" },
  green: { background: "#effbf4", border: "#c9eed9", text: "#279653", dot: "#24a661" },
  purple: { background: "#f4f0ff", border: "#dcd0fb", text: "#6d3fd1", dot: "#8b5cf6" },
  orange: { background: "#fff1e6", border: "#f5b98a", text: "#c2410c", dot: "#f97316" },
  red: { background: "#fff0f5", border: "#fbc4d8", text: "#c8105a", dot: "#f9156f" },
  grey: { background: "#f7f7f8", border: "#e1e3ea", text: "#757a88", dot: "#a3a7b3" },
};

const SOCIAL_FUND_STATUS_TONE_BY_CODE = {
  received: "blue",
  in_review_a51: "blue",
  pending_director_review: "amber",
  approved: "green",
  rejected: "red",
  approved_for_payment: "purple",
  paid: "orange",
  closed: "grey",
};

export const getSocialFundStatusTone = (statusCode) =>
  SOCIAL_FUND_STATUS_TONES[SOCIAL_FUND_STATUS_TONE_BY_CODE[statusCode]] || SOCIAL_FUND_STATUS_TONES.grey;

// Variables CSS para los componentes: --status-bg, --status-border,
// --status-text y --status-dot.
export const getSocialFundStatusStyle = (statusCode) => {
  const tone = getSocialFundStatusTone(statusCode);
  return {
    "--status-bg": tone.background,
    "--status-border": tone.border,
    "--status-text": tone.text,
    "--status-dot": tone.dot,
  };
};
